import React, { useEffect } from 'react'
import styles from './BadgePill.module.css'
import Image from 'next/image'
import { filterClearIcon } from '../../../public/icons'
interface Props {
  FilterName: string
  FilterValue: string
  clearFilter: () => void
}

const BadgePill = ({ FilterName, FilterValue, clearFilter }: Props) => {
  useEffect(() => {
  }, [FilterName, FilterValue])
  return (
    <>



      <div className={`d-flex rounded-4 fw-light fs-12 shadow-sm ${styles.fit} ${styles.filter_name} px-2 py-1 my-0 border text-dark align-items-end text-nowrap ${styles.pill_shadow}`}>
        <div className=" me-1 rounded-start-3 py-0 my-0">
          <span className="py-0 my-0 fw-normal">{FilterName}</span>
        </div>
        <div className="vr"></div>
        <div className=" mx-1 py-0 my-0">
          <span className="me-1 py-0 my-0 fw-bold">{FilterValue}</span>
        </div>
        <div onClick={clearFilter} className="  rounded-end-3 fw-bold cursor-pointer">
          <span>    <Image
            className="float-end me-2"
            src={filterClearIcon}
            alt="clearIcon"
            width={16}
            height={16}
          /></span>
        </div>
      </div>

    </>

  )
}

export default BadgePill